<template>
    <div class="stepper">
        <div
            :style="IsActive(index)?`background:${ConfigElementsColor}`:''"
            class="step outfit-font" v-html="step"
            v-for="(step, index) in steps"
            :class="StepClass(index)"
            @click="EmitClick(index)"
            :key="index">
        </div>
    </div>
</template>

<script>
import {CommonMixins} from "@/mixins/CommonMixins";

export default {
    props: ['steps','active_step'],
    name: 'Stepper',
    mixins: [CommonMixins],
    methods: {
        IsActive(index) {
            return index === this.active_step
        },
        StepClass(index) {
            return {
                active: index === this.active_step,
                last: index === this.steps.length-1
            }
        },
        EmitClick(index) {
            if (index == (this.steps.length-1)) {
                this.$emit('addToCart')
            }
        }
    }
}
</script>
<style scoped lang="scss">
.stepper {
    display: flex;
    font-family: sans-serif;
    @media (max-width: 500px) {
        display: none !important;
    }
}
.step {
    position: relative;
    background-color: #e0e0e0;
    padding: 10px 30px;
    color: #333;
    cursor: pointer;
    width: fit-content;
    text-align: center;
    user-select: none;
    margin-right: -20px;
    z-index: 1;
    transition: background-color 0.3s;
    clip-path: polygon(
        0% 0%,
        92% 0%,
        100% 50%,
        92% 100%,
        0% 100%,
        8% 50%
    );
    &:first-child {
        clip-path: polygon(
            0% 0%,
            92% 0%,
            100% 50%,
            92% 100%,
            0% 100%
        );
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        padding-left: 12px;
        cursor: default;
    }
    &:hover {
        background-color: #c6c6c6;
    }
    &.active {
        color: white;
        z-index: 2;
    }
}
</style>
